function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { Emitter, getDefaultElementPosition, getDefaultOffset, getDefaultOverflowBoundaries, getDocScroll, getWindowSize, isFixed } from '@bydesign-ui/hooks';
import { clone, guid, shallowEqual } from '@bydesign-ui/utils';
export var reversedDirection = {
  left: 'right',
  top: 'bottom',
  right: 'left',
  bottom: 'top'
};
export var touchReverse = {
  left: 'right',
  top: 'bottom',
  right: 'left',
  bottom: 'top'
};
export function getDefaultTouch() {
  return {
    touchX: false,
    touchY: false,
    fixed: false
  };
}
export function getDefaultArrowInfo(placement) {
  var arrowInfo = {
    arrowStyle: {},
    arrowDirection: ''
  };

  if (!placement) {
    return arrowInfo;
  }

  var _placement$split = placement.split('-'),
      _placement$split2 = _slicedToArray(_placement$split, 1),
      dir = _placement$split2[0];

  return Object.assign(arrowInfo, {
    arrowDirection: touchReverse[dir]
  });
}
export var Popover = function (_Emitter) {
  _inherits(Popover, _Emitter);

  var _super = _createSuper(Popover);

  function Popover(params) {
    var _this;

    _classCallCheck(this, Popover);

    _this = _super.call(this);
    _this.arrowInfo = getDefaultArrowInfo();
    _this.arrow = false;
    _this.triggerIds = [];
    _this.lastTrigger = '';
    _this.sideDirectionDict = {
      top: {
        sides: ['left', 'right'],
        range: 'width'
      },
      bottom: {
        sides: ['left', 'right'],
        range: 'width'
      },
      left: {
        sides: ['top', 'bottom'],
        range: 'height'
      },
      right: {
        sides: ['top', 'bottom'],
        range: 'height'
      }
    };
    _this.refType = 'lastTrigger';
    _this.refId = '';
    _this.unionPopoverIds = [];
    _this.placement = 'bottom-start';
    _this.offset = getDefaultOffset();
    _this.preventOverflow = true;
    _this.boundariesDetectionDebounce = false;
    _this.overflowBoundaries = getDefaultOverflowBoundaries();
    _this.arrowOffset = getDefaultOffset();
    _this.popoverTouch = getDefaultTouch();
    _this.popover = null;
    _this.popoverStyle = {};
    _this.preventAroundOverflow = false;
    _this.rect = getDefaultElementPosition();
    _this.disposed = false;
    _this.id = params.id || guid();
    _this.popper = params.popper;
    _this.singleGroupId = params.singleGroupId || _this.id;

    _this.popper.registerPopover(_assertThisInitialized(_this));

    _this.updatePopoverOptions(params.options);

    return _this;
  }

  _createClass(Popover, [{
    key: "updatePopover",
    value: function updatePopover(element) {
      this.popover = element;
    }
  }, {
    key: "updatePopoverOptions",
    value: function updatePopoverOptions(options) {
      var show = options.show,
          _options$refType = options.refType,
          refType = _options$refType === void 0 ? 'lastTrigger' : _options$refType,
          _options$refId = options.refId,
          refId = _options$refId === void 0 ? '' : _options$refId,
          _options$triggerIds = options.triggerIds,
          triggerIds = _options$triggerIds === void 0 ? [] : _options$triggerIds,
          _options$unionPopover = options.unionPopoverIds,
          unionPopoverIds = _options$unionPopover === void 0 ? [] : _options$unionPopover,
          _options$placement = options.placement,
          placement = _options$placement === void 0 ? 'bottom-start' : _options$placement,
          _options$offset = options.offset,
          offset = _options$offset === void 0 ? getDefaultOffset() : _options$offset,
          _options$preventOverf = options.preventOverflow,
          preventOverflow = _options$preventOverf === void 0 ? true : _options$preventOverf,
          _options$overflowBoun = options.overflowBoundaries,
          overflowBoundaries = _options$overflowBoun === void 0 ? getDefaultOverflowBoundaries() : _options$overflowBoun,
          _options$arrow = options.arrow,
          arrow = _options$arrow === void 0 ? false : _options$arrow,
          _options$arrowOffset = options.arrowOffset,
          arrowOffset = _options$arrowOffset === void 0 ? getDefaultOffset() : _options$arrowOffset,
          _options$preventAroun = options.preventAroundOverflow,
          preventAroundOverflow = _options$preventAroun === void 0 ? false : _options$preventAroun,
          _options$boundariesDe = options.boundariesDetectionDebounce,
          boundariesDetectionDebounce = _options$boundariesDe === void 0 ? false : _options$boundariesDe;
      this.refType = refType;
      this.refId = refId;
      this.triggerIds = triggerIds;
      this.unionPopoverIds = unionPopoverIds;
      this.placement = placement;
      this.offset = offset;
      this.preventOverflow = preventOverflow;
      this.boundariesDetectionDebounce = boundariesDetectionDebounce;
      this.overflowBoundaries = overflowBoundaries;
      this.preventAroundOverflow = preventAroundOverflow;
      this.arrow = arrow;
      this.arrowOffset = arrowOffset;
      this.popper.setPopoverShow(this.id, show);
      this.popoverStyle = this.updatePopperStyle();
    }
  }, {
    key: "dispose",
    value: function dispose() {
      if (this.disposed) {
        return;
      }

      this.popper.unregisterPopover(this);
      this.disposed = true;
    }
  }, {
    key: "getId",
    value: function getId() {
      return this.id;
    }
  }, {
    key: "getGroupId",
    value: function getGroupId() {
      return this.singleGroupId;
    }
  }, {
    key: "getPopoverStyle",
    value: function getPopoverStyle() {
      return this.popoverStyle || {};
    }
  }, {
    key: "getArrowStyle",
    value: function getArrowStyle() {
      return this.arrowInfo.arrowStyle || {};
    }
  }, {
    key: "getPopoverFixed",
    value: function getPopoverFixed() {
      var ref = this.getPopover();

      if (ref == null) {
        return false;
      }

      return isFixed(ref);
    }
  }, {
    key: "getTriggerIds",
    value: function getTriggerIds() {
      return this.triggerIds;
    }
  }, {
    key: "getRefId",
    value: function getRefId() {
      return this.refId;
    }
  }, {
    key: "getRefType",
    value: function getRefType() {
      return this.refType;
    }
  }, {
    key: "setLastTrigger",
    value: function setLastTrigger(triggerId) {
      this.lastTrigger = triggerId;
    }
  }, {
    key: "getLastTrigger",
    value: function getLastTrigger() {
      return this.lastTrigger;
    }
  }, {
    key: "getUnionPopoverIds",
    value: function getUnionPopoverIds() {
      return this.unionPopoverIds;
    }
  }, {
    key: "showPopover",
    value: function showPopover() {
      if (this.popper.isActiveShow(this.lastTrigger)) {
        this.popoverStyle = this.updatePopperStyle();
        this.emit('popover-style', this.popoverStyle);
        return;
      }

      this.popper.syncSingleGroup(this.getGroupId(), this.getId());
      this.popper.setActiveShow(this.lastTrigger);
      this.emit('popover-show', true);
    }
  }, {
    key: "hidePopover",
    value: function hidePopover() {
      this.lastTrigger && this.popper.cancelActiveShow(this.lastTrigger);
      this.emit('popover-show', false);
    }
  }, {
    key: "isShow",
    value: function isShow() {
      return this.popper.isPopoverShow(this.id);
    }
  }, {
    key: "updateRefRect",
    value: function updateRefRect() {
      this.popoverStyle = this.updatePopperStyle();

      if (this.isShow()) {
        this.emit('popover-style', this.popoverStyle);
      }
    }
  }, {
    key: "updateRect",
    value: function updateRect(rect) {
      this.rect = rect;
      this.popoverStyle = this.updatePopperStyle();

      if (this.isShow()) {
        this.emit('popover-style', this.popoverStyle);
        this.popper.updatePopoverRect(this.id);
      }
    }
  }, {
    key: "getRect",
    value: function getRect() {
      return this.rect;
    }
  }, {
    key: "getTriggerData",
    value: function getTriggerData() {
      if (!this.lastTrigger) {
        return null;
      }

      return this.popper.getTrigger(this.lastTrigger).getData();
    }
  }, {
    key: "onPopperMouseEnter",
    value: function onPopperMouseEnter() {
      if (!this.lastTrigger) {
        return;
      }

      var lastTrigger = this.popper.getTrigger(this.lastTrigger);

      if (!lastTrigger || lastTrigger.getTriggerType() !== 'hover') {
        return;
      }

      this.popper.getTrigger(this.lastTrigger).showPopper();
    }
  }, {
    key: "onPopperMouseLeave",
    value: function onPopperMouseLeave() {
      if (!this.lastTrigger) {
        return;
      }

      var lastTrigger = this.popper.getTrigger(this.lastTrigger);

      if (!lastTrigger || lastTrigger.getTriggerType() !== 'hover') {
        return;
      }

      this.popper.getTrigger(this.lastTrigger).hidePopper();
    }
  }, {
    key: "onPopperFocus",
    value: function onPopperFocus() {
      if (!this.lastTrigger) {
        return;
      }

      var lastTrigger = this.popper.getTrigger(this.lastTrigger);

      if (!lastTrigger || lastTrigger.getTriggerType() !== 'focus') {
        return;
      }

      this.popper.getTrigger(this.lastTrigger).showPopper();
    }
  }, {
    key: "onPopperBlur",
    value: function onPopperBlur() {
      if (!this.lastTrigger) {
        return;
      }

      var lastTrigger = this.popper.getTrigger(this.lastTrigger);

      if (!lastTrigger || lastTrigger.getTriggerType() !== 'focus') {
        return;
      }

      this.popper.getTrigger(this.lastTrigger).hidePopper();
    }
  }, {
    key: "getRefTriggerId",
    value: function getRefTriggerId() {
      var refId = this.refId,
          refType = this.refType;

      if (refType === 'trigger') {
        return refId;
      }

      if (refType === 'popover') {
        return '';
      }

      return this.getLastTrigger();
    }
  }, {
    key: "getRefFixed",
    value: function getRefFixed() {
      try {
        switch (this.refType) {
          case 'trigger':
            return this.popper.getTrigger(this.refId).isTriggerFixed();

          case 'popover':
            return this.popper.getPopover(this.refId).getPopoverFixed();

          case 'lastTrigger':
            return this.popper.getTrigger(this.lastTrigger).isTriggerFixed();

          default:
            return false;
        }
      } catch (e) {
        return false;
      }
    }
  }, {
    key: "getRefRect",
    value: function getRefRect() {
      var ref = null;

      switch (this.refType) {
        case 'trigger':
          ref = this.popper.getTrigger(this.refId);
          break;

        case 'popover':
          ref = this.popper.getPopover(this.refId);
          break;

        case 'lastTrigger':
          ref = this.popper.getTrigger(this.lastTrigger);
      }

      return ref ? ref.getRect() : getDefaultElementPosition();
    }
  }, {
    key: "updatePopperStyle",
    value: function updatePopperStyle() {
      var popoverRect = _objectSpread({}, this.rect);

      var refRect = this.getRefRect();

      var _this$getOffsetByPlac = this.getOffsetByPlacement(),
          x = _this$getOffsetByPlac.x,
          y = _this$getOffsetByPlac.y;

      var left = refRect.left + x + (this.offset.x || 0);
      var top = refRect.top + y + (this.offset.y || 0);
      Object.assign(popoverRect, {
        left: left,
        top: top,
        right: left + popoverRect.width,
        bottom: top + popoverRect.height
      });

      var _this$getRectByOverfl = this.getRectByOverflowBoundaries(popoverRect, this.popoverTouch),
          _this$getRectByOverfl2 = _slicedToArray(_this$getRectByOverfl, 2),
          touchPopperRect = _this$getRectByOverfl2[0],
          touch = _this$getRectByOverfl2[1];

      var fixed = this.getRefFixed() || touch.fixed;
      var popStyle = {
        position: fixed ? 'fixed' : 'absolute'
      };

      var _getDocScroll = getDocScroll(),
          scrollLeft = _getDocScroll.scrollLeft,
          scrollTop = _getDocScroll.scrollTop;

      if (fixed) {
        scrollLeft = 0;
        scrollTop = 0;
      }

      if (this.preventOverflow && (touch.touchX || touch.touchY)) {
        popStyle.left = Math.floor(touchPopperRect.left + scrollLeft) + 'px';
        popStyle.top = Math.floor(touchPopperRect.top + scrollTop) + 'px';
      } else {
        popStyle.left = Math.floor(popoverRect.left + scrollLeft) + 'px';
        popStyle.top = Math.floor(popoverRect.top + scrollTop) + 'px';
      }

      if (this.arrow) {
        this.arrowInfo = this.getArrowInfo(popoverRect, touch);
        this.emit('arrow-info-change', this.arrowInfo);
      }

      if (!shallowEqual(this.popoverTouch, touch)) {
        this.popoverTouch = touch;
        this.emit('touch-change', touch);
      }

      return popStyle;
    }
  }, {
    key: "getArrowInfo",
    value: function getArrowInfo(popoverRect, popoverTouch) {
      var _this$placement$split = this.placement.split('-'),
          _this$placement$split2 = _slicedToArray(_this$placement$split, 2),
          direction = _this$placement$split2[0],
          _this$placement$split3 = _this$placement$split2[1],
          pos = _this$placement$split3 === void 0 ? 'center' : _this$placement$split3;

      var touchX = popoverTouch.touchX,
          touchY = popoverTouch.touchY;
      var arrowStyle = {
        position: 'absolute',
        lineHeight: 0,
        fontSize: 0
      };
      var isVertical = direction === 'top' || direction === 'bottom';
      var axisPos = {
        vertical: {
          start: this.arrowOffset.y,
          center: popoverRect.height / 2 + this.arrowOffset.y,
          end: popoverRect.height + this.arrowOffset.y
        },
        horizontal: {
          start: this.arrowOffset.x,
          center: popoverRect.width / 2 + this.arrowOffset.x,
          end: popoverRect.width + this.arrowOffset.x
        }
      };
      var transformPos = {
        start: '0',
        center: '-50%',
        end: '-100%'
      };
      var dir = isVertical ? touchY ? touchReverse[direction] : direction : touchX ? touchReverse[direction] : direction;

      switch (dir) {
        case 'right':
          Object.assign(arrowStyle, {
            left: 0,
            transform: "translate(-100%, ".concat(transformPos[pos], ")"),
            top: axisPos.vertical[pos] + 'px'
          });
          break;

        case 'left':
          Object.assign(arrowStyle, {
            left: popoverRect.width + 'px',
            transform: "translate(0, ".concat(transformPos[pos], ")"),
            top: axisPos.vertical[pos] + 'px'
          });
          break;

        case 'bottom':
          Object.assign(arrowStyle, {
            top: 0,
            transform: "translate(".concat(transformPos[pos], ", -100%)"),
            left: axisPos.horizontal[pos] + 'px'
          });
          break;

        case 'top':
          Object.assign(arrowStyle, {
            top: popoverRect.height + 'px',
            transform: "translate(".concat(transformPos[pos], ", 0)"),
            left: axisPos.horizontal[pos] + 'px'
          });
          break;
      }

      return {
        arrowStyle: arrowStyle,
        arrowDirection: touchReverse[dir]
      };
    }
  }, {
    key: "getOffsetByPlacement",
    value: function getOffsetByPlacement() {
      var _this$placement$split4 = this.placement.split('-'),
          _this$placement$split5 = _slicedToArray(_this$placement$split4, 2),
          direction = _this$placement$split5[0],
          _this$placement$split6 = _this$placement$split5[1],
          pos = _this$placement$split6 === void 0 ? 'center' : _this$placement$split6;

      var _this$rect = this.rect,
          popoverWidth = _this$rect.width,
          popoverHeight = _this$rect.height;

      var _this$getRefRect = this.getRefRect(),
          refWidth = _this$getRefRect.width,
          refHeight = _this$getRefRect.height;

      var res = getDefaultOffset();
      var axisOffset = {
        vertical: {
          start: 0,
          center: (refWidth - popoverWidth) / 2,
          end: refWidth - popoverWidth
        },
        horizontal: {
          start: 0,
          center: (refHeight - popoverHeight) / 2,
          end: refHeight - popoverHeight
        }
      };

      switch (direction) {
        case 'top':
          Object.assign(res, {
            y: -popoverHeight,
            x: axisOffset.vertical[pos]
          });
          break;

        case 'bottom':
          Object.assign(res, {
            y: refHeight,
            x: axisOffset.vertical[pos]
          });
          break;

        case 'left':
          Object.assign(res, {
            y: axisOffset.horizontal[pos],
            x: -popoverWidth
          });
          break;

        case 'right':
          Object.assign(res, {
            y: axisOffset.horizontal[pos],
            x: refWidth
          });
          break;
      }

      return res;
    }
  }, {
    key: "getAvailBoundaries",
    value: function getAvailBoundaries() {
      var _this$overflowBoundar = this.overflowBoundaries,
          _this$overflowBoundar2 = _this$overflowBoundar.left,
          left = _this$overflowBoundar2 === void 0 ? 0 : _this$overflowBoundar2,
          _this$overflowBoundar3 = _this$overflowBoundar.top,
          top = _this$overflowBoundar3 === void 0 ? 0 : _this$overflowBoundar3,
          _this$overflowBoundar4 = _this$overflowBoundar.right,
          right = _this$overflowBoundar4 === void 0 ? 0 : _this$overflowBoundar4,
          _this$overflowBoundar5 = _this$overflowBoundar.bottom,
          bottom = _this$overflowBoundar5 === void 0 ? 0 : _this$overflowBoundar5;

      var _getWindowSize = getWindowSize(),
          width = _getWindowSize.width,
          height = _getWindowSize.height;

      return {
        left: left,
        top: top,
        right: width - right,
        bottom: height - bottom
      };
    }
  }, {
    key: "getRectByOverflowBoundaries",
    value: function getRectByOverflowBoundaries(popoverRect, currentTouch) {
      var newRect = clone(popoverRect);
      var availBoundaries = this.getAvailBoundaries();
      var direction = this.placement.split('-')[0];
      var isVertical = direction === 'top' || direction === 'bottom';
      var res = getDefaultTouch();
      var refRect = this.getRefRect();
      var shouldFlip = this.boundariesDetectionDebounce && currentTouch[isVertical ? 'touchY' : 'touchX'] || this.isRectOverBoundary(availBoundaries, newRect, direction);

      if (shouldFlip) {
        var reversedDir = reversedDirection[direction];
        var nextValue = refRect[reversedDir] - this.offset[isVertical ? 'y' : 'x'];

        var flippedRect = _objectSpread({}, newRect);

        this.assignRectValue(flippedRect, direction, nextValue);

        if (this.isRectOverBoundary(availBoundaries, flippedRect, reversedDir)) {
          this.assignRectValue(newRect, direction, nextValue);
        } else {
          res[isVertical ? 'touchY' : 'touchX'] = true;
          Object.assign(newRect, flippedRect);
        }
      }

      var _this$sideDirectionDi = this.sideDirectionDict[direction],
          sides = _this$sideDirectionDi.sides,
          range = _this$sideDirectionDi.range;

      if (!this.preventAroundOverflow || newRect[range] > getWindowSize()[range]) {
        return [newRect, res];
      }

      var _iterator = _createForOfIteratorHelper(sides),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var side = _step.value;

          if (this.isRectOverBoundary(availBoundaries, newRect, side)) {
            var _isVertical = side === 'top' || side === 'bottom';

            res[_isVertical ? 'touchY' : 'touchX'] = true;
            var _nextValue = availBoundaries[side];
            this.assignRectValue(newRect, side, _nextValue);
            break;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return [newRect, res];
    }
  }, {
    key: "getPopover",
    value: function getPopover() {
      return this.popover || null;
    }
  }, {
    key: "assignRectValue",
    value: function assignRectValue(rect, direction, value) {
      if (direction === 'top') {
        rect.top = value;
        rect.bottom = rect.top + rect.height;
      } else if (direction === 'left') {
        rect.left = value;
        rect.right = rect.left + rect.width;
      } else if (direction === 'right') {
        rect.right = value;
        rect.left = rect.right - rect.width;
      } else {
        rect.bottom = value;
        rect.top = rect.bottom - rect.height;
      }
    }
  }, {
    key: "isRectOverBoundary",
    value: function isRectOverBoundary(boundary, rect, direction) {
      if (direction === 'top' || direction === 'left') {
        return boundary[direction] > rect[direction];
      }

      return boundary[direction] < rect[direction];
    }
  }]);

  return Popover;
}(Emitter);